import React, {useCallback, useState} from "react";
import intl from "react-intl-universal";
import {useAppState, useAuthService, useDataClientService, useUserState} from "@stores/AppStateContext";

import {Workspace} from "../../../../API";

import {InfoIcon} from "../../../components/icons/InfoIcon";
import {ModalConfirm} from "../../../components/ModalConfirm";
import {createWorkspaceUser} from "../../../../actions/workspaceUser/createWorkspaceUser";
import {MultiSelectWorkspaceMembers} from "../../../components/SelectTypes/MultiSelectWorkspaceMembers";

import {MODALS} from "../modal-names";

import {snackBarRef} from "@stores/snackbarRef";


import "./AddMembersWorkspace.css"


export interface AddMembersWorkspaceModalProps {
    workspace: Workspace,
}

export const AddMembersWorkspace = (props: AddMembersWorkspaceModalProps) => {
    const appState = useAppState();
    const authService = useAuthService();
    const dataClients = useDataClientService();
    const userState = useUserState();

    const [selectedUsers, setSelectedUsers] = useState<string[] | null>(null);
    const enqueueSnackbar = snackBarRef.current!.enqueueSnackbar;
    const handleClose = useCallback(() => {
        appState.setModal(null)
        appState.setContextMenu(null)
    }, []);

    const activeModal = appState.topModal;

    const handleConfirm = async () => {
        try {
            if (selectedUsers) {
                const promises = selectedUsers.map(userId => {
                    const userRole = userState!.getUserRole(userState!.usersDS.users.get(userId));
                    return createWorkspaceUser(dataClients, authService, userState!, props.workspace.id, userId, userRole ? userRole : 'reader');
                });

                await Promise.all(promises);
            }
            appState.setModal(null);
            enqueueSnackbar({
                message: intl.get('workspace.add.members.snackbar').d('Members added to the workspace'),
                variant: 'success',
            });
        } catch (error) {
            console.error('Error during workspace deletion:', error);
        }
    };

    return (
        <ModalConfirm
            onConfirm={handleConfirm}
            confirmText={intl.get('addMembers_workspaceModal.confirm.button').d('Add members')}
            onCancel={handleClose}
            header={intl.get('addMembers_workspaceModal.header').d('Add workspace members')}
            open={activeModal === MODALS.ADD_MEMBERS_WORKSPACE}
            onClose={handleClose}
            subtitle={intl.get('addMembers_workspaceModal.topText').d('Add company members to this workspace.')}
            children={
                <>
                    <div>
                        <MultiSelectWorkspaceMembers
                            value={selectedUsers}
                            onChange={setSelectedUsers}
                            placeholder={intl.get('addMembers_workspaceModal.select_users').d('Add members (optional)')}
                            className="AddMembersWorkspace__SelectUsers"
                            onlyAvailableToBeAdded={true}
                            targetWorkspaceId={props.workspace.id}
                        />
                    </div>
                    <div className={"addMembersWorkspace__SelectUsers__description"}>
                        <InfoIcon size={16}/>
                        <span className="addMembersWorkspace__SelectUsers__descriptionText body-small">
                            {intl.get('create_workspaceModal.bottomText').d('Access rights (roles) of added members are currently the same across all workspaces.')}
                        </span>
                    </div>
                </>
            }
        />
    );
}

